export const I18N_MESSAGES: any = {
  it: {
    done: "Fine",
    editDone: "Torna al carrello",
    next: "Avanti",
    closePreview: "Chiudi anteprima",
    configuratorOnboarding: {
      basic:
        "Per iniziare scegli il colore di sfondo o inserisci un'immagine, un testo o una emoji! Poi potrai routarli, ingrandirli e spostarli con le dita",
      slider:
        "Nel caso di prodotti con più lati, puoi aprire lo slider per cambiare il lato che vuoi personalizzare",
      start: "Iniziamo!",
      color_picker: "Clicca su un pixel per copiare il suo colore",
    },
    dialogs: {
      back_title: "Vuoi eliminare le modifiche?",
      back_when_in_cart_title: "Uscire?",
      back_positive_action: "Continua la modifica",
      back_negative_action: "Esci",
    },
    warnings: {
      use_our_emojis: "Utilizza le emoji nella tab emoji",
      image_too_big:
        "Oops! Sembra che l'immagine che stai caricando sia troppo grossa.😬",
      update_failed: "Oops! L'aggiornamento della grafica è fallito.😬",
      upload_failed: "Oops! Il caricamento dell'immagine è fallito.😬",
      load_failed:
        "Oops! Non è stato possibile caricare la personalizzazione.😬",
      back_when_product_in_cart: "Sei sicuro di tornare al carrello?",
      back_when_product_is_new:
        "Uscendo ora perderai il tuo disegno e non potrai recuperarlo",
    },
    sharing: {
      clipboard_success: "Link copiato!",
      text: "Guarda qui 😎!",
      success: "Condiviso ✅!",
      failure: "Problemi, problemi, problemi 🛑!",
      title: "la tua personalizzazione iLMYO",
    },
    addToCart: "Aggiungi al carrello",
    preview3D: "Anteprima 3D",
    recap: {
      back: "Torna alla modifica",
      addToCart: "Aggiungi al carrello",
      editDone: "Torna al carrello",
    },
    side_menu: {
      share: "Condividi",
      rollback: "Annulla",
      zoom: "Zoom",
      guide: "Guida",
    },
    errors: {
      notFoundAction: "Torna al negozio",
      notFoundTitle: "OPS!",
      notFoundMessage: "Sbagliato strada?",
    },
    terms: {
      confirm: "Confermo",
      title: "Termini e condizioni",
      warning:
        "Attenzione: La resa dei colori stampati sul prodotto potrebbero differire leggermente dalla foto originale. Immagini scure o molto sature potrebbero non risultare come nell'anteprima visibile sul tuo schermo. Ti consigliamo di schiarire leggermente le immagini troppo scure per ottenere un risultato ottimale.",
      content:
        "Mi assumo ogni responsabilità relativa all’utilizzo di immagini o grafiche da me caricate sul sito web e sollevo Ilmyo da ogni responsabilità derivante dalla violazione della legge sul diritto di copyright e da contenuti offensivi e diffamatori.",
      checkbox: "Confermo di aver preso visione dei Termini e Condizioni.",
    },
    onboarding: {
      backButton: "Per abbandonare la personalizzazione premi qui",
      bgButton: "Se invece vuoi cambiare il colore di sfondo puoi premere qui",
      textButton:
        "Se invece vuoi aggiungere del testo, questo è il pulsante che fa per te",
      imgButton: "Qui puoi caricare le tue fantastiche foto",
      emojiButton: "Voglia di emoji? Cercale qui!",
      previewButton:
        "Curioso di sapere come sarà il tuo prodotto? Guardalo in 3D",
      nextButton:
        "Finito? Allora premi qui per personalizzare l'area di stampa successiva o per aggiungere al carrello",
      skip: "Salta",
    },
    recap_warning_1: "Per continuare assicurati di aver aggiunto",
    recap_warning_2: "almeno un testo o un'immagine",
    recap_warning_3: "in ogni articolo",
    configurator: { swipeToDelete: "Trascina per eliminare" },
  },
  en: {
    done: "Done",
    warnings: {
      use_our_emojis: "Use our emoji in the emoji tab",
      image_too_big:
        "Oops! It looks like the image you're trying to upload is too large.😬",
      update_failed: "Oops! Design update failed.😬",
      upload_failed: "Oops! Image upload failed.😬",
      load_failed: "Oops! We couldn't load your customization.😬",
      back_when_product_in_cart:
        "By going back you will lose any change made to your design",
      back_when_product_is_new: "By going back you will lose your design",
    },
    terms: {
      warning:
        "Attention: The printed colors on the product may differ slightly from the original photo. Dark or highly saturated images might not appear as they do in the preview on your screen. We recommend slightly brightening images that are too dark to achieve an optimal result.",
      confirm: "I confirm",
      title: "Terms and Conditions",
      content:
        "I assume all responsibility for the use of images or graphics that I have uploaded to the website and I relieve Ilmyo from any responsibility arising from the violation of copyright laws and from offensive and defamatory content.",
      checkbox:
        "I confirm that I have read and understood the Terms and Conditions.",
    },
    sharing: {
      clipboard_success: "Copied to clipboard!",
      success: "Shared ✅!",
      failure: "Could not share 🛑!",
      text: "Check this out 😎",
      title: "Your iLMYO customization",
    },
    editDone: "Back to cart",
    next: "Next",
    closePreview: "Close preview",
    configuratorOnboarding: {
      basic:
        "Start by choosing a background color or insert an image, text or emojis! Than you can rotate, resize and change position of the items you insert with your fingers",
      slider:
        "With products which have multiple sides, you can use the slider to change the side you want to customize",
      start: "Let's start!",
      color_picker: "Click on a specific pixel of the image to copy its color",
    },
    addToCart: "Add to cart",
    preview3D: "3D Preview",
    recap: {
      back: "Go back to the customizer",
      addToCart: "Add to cart",
      editDone: "Back to cart",
    },
    side_menu: {
      share: "Share",
      rollback: "Rollback",
      zoom: "Zoom",
      guide: "Guide",
    },
    dialogs: {
      back_title: "",
      back_positive_action: "Keep editing",
      back_negative_action: "Close",
    },
    onboarding: {
      backButton: "Tap here if you want to leave the customization",
      bgButton: "Tap here if you'd like to change the background of the canvas",
      textButton: "Want to add any text with colors and fonts? Tap here then",
      imgButton: "Tap here if you'd like to upload a picture",
      emojiButton: "Need some emojis? Tap here",
      previewButton:
        "Curious about how your customization will look? You may want to see it rendered in 3D",
      nextButton:
        "Tap here to continue with your customization or to add your product to the shopping cart",
      skip: "Skip",
    },
    errors: {
      notFoundMessage: "There's nothing here",
      notFoundTitle: "SH*T!",
      notFoundAction: "Back to the store",
    },
    recap_warning_1: "To complete your order please make sure",
    recap_warning_2: "there was at least an image or text",
    recap_warning_3: "in each print area of the product",
    configurator: { swipeToDelete: "Swipe to delete" },
  },
  es: {
    done: "Hecho",
    editDone: "Volver al carrito",
    next: "Siguiente",
    closePreview: "Cerrar vista previa",
    configuratorOnboarding: {
      basic:
        "¡Para comenzar, elige un color de fondo o inserta una imagen, un texto o un emoji! Luego podrás rotarlos, agrandarlos y moverlos con los dedos",
      slider:
        "En el caso de productos con varios lados, puedes abrir el deslizador para cambiar el lado que deseas personalizar",
      start: "¡Empecemos!",
      color_picker: "Haz clic en un píxel para copiar su color",
    },
    dialogs: {
      back_title: "¿Quieres eliminar los cambios?",
      back_when_in_cart_title: "¿Salir?",
      back_positive_action: "Continua editando",
      back_negative_action: "Salir",
    },
    terms: {
      warning:
        "Atención: Los colores impresos en el producto pueden diferir ligeramente de la foto original. Las imágenes oscuras o muy saturadas pueden no aparecer como en la vista previa visible en tu pantalla. Recomendamos aclarar ligeramente las imágenes demasiado oscuras para obtener un resultado óptimo.",
      confirm: "Confirmo",
      title: "Términos y Condiciones",
      content:
        "Asumo toda la responsabilidad por el uso de imágenes o gráficos que he subido al sitio web y libero a Ilmyo de cualquier responsabilidad que surja de la violación de las leyes de derechos de autor y de contenidos ofensivos y difamatorios.",
      checkbox: "Confirmo que he leído y entendido los Términos y Condiciones.",
    },
    warnings: {
      use_our_emojis: "Utiliza los emojis en la pestaña de emojis",
      image_too_big:
        "Uy! Parece que la imagen que estás intentando subir es demasiado grande.😬",
      update_failed: "Uy! La actualización del diseño ha fallado.😬",
      upload_failed: "Uy! La subida de la imagen ha fallado.😬",
      load_failed: "Uy! No se pudo cargar tu personalización.😬",
      back_when_product_in_cart:
        "¿Estás seguro de que quieres volver al carrito?",
      back_when_product_is_new:
        "Si sales ahora, perderás tu diseño y no podrás recuperarlo",
    },
    sharing: {
      clipboard_success: "¡Enlace copiado!",
      text: "¡Mira esto 😎!",
      success: "¡Compartido ✅!",
      failure: "Problemas, problemas, problemas 🛑!",
      title: "tu personalización iLMYO",
    },
    addToCart: "Agregar al carrito",
    preview3D: "Vista previa en 3D",
    recap: {
      back: "Volver a la edición",
      addToCart: "Agregar al carrito",
      editDone: "Volver al carrito",
    },
    side_menu: {
      share: "Compartir",
      rollback: "Deshacer",
      zoom: "Zoom",
      guide: "Guía",
    },
    errors: {
      notFoundAction: "Volver a la tienda",
      notFoundTitle: "¡Vaya!",
      notFoundMessage: "¿Caminaste por el camino incorrecto?",
    },
    onboarding: {
      backButton: "Para abandonar la personalización, presiona aquí",
      bgButton: "Si quieres cambiar el color de fondo, puedes presionar aquí",
      textButton: "Si quieres agregar texto, este es el botón para ti",
      imgButton: "Aquí puedes subir tus increíbles fotos",
      emojiButton: "¿Quieres emojis? ¡Búscalos aquí!",
      previewButton: "¿Curioso de cómo será tu producto? Míralo en 3D",
      nextButton:
        "¿Terminaste? Entonces presiona aquí para personalizar el área de impresión siguiente o para agregar al carrito",
      skip: "Omitir",
    },
    recap_warning_1: "Para continuar, asegúrate de haber agregado",
    recap_warning_2: "al menos un texto o una imagen",
    recap_warning_3: "en cada artículo",
    configurator: { swipeToDelete: "Desliza para eliminar" },
  },
  de: {
    done: "Fertig",
    editDone: "Zurück zum Warenkorb",
    next: "Weiter",
    closePreview: "Vorschau schließen",
    configuratorOnboarding: {
      basic:
        "Wählen Sie zunächst eine Hintergrundfarbe aus oder fügen Sie ein Bild, einen Text oder ein Emoji hinzu! Dann können Sie sie mit Ihren Fingern drehen, vergrößern und bewegen",
      slider:
        "Bei Produkten mit mehreren Seiten können Sie den Schieberegler öffnen, um die Seite zu ändern, die Sie anpassen möchten",
      start: "Lass uns anfangen!",
      color_picker: "Klicken Sie auf ein Pixel, um seine Farbe zu kopieren",
    },
    dialogs: {
      back_title: "Möchten Sie die Änderungen löschen?",
      back_when_in_cart_title: "Ausgang?",
      back_positive_action: "Bearbeitung fortsetzen",
      back_negative_action: "Verlassen",
    },
    terms: {
      warning:
        "Achtung: Die gedruckten Farben auf dem Produkt können leicht von dem Originalfoto abweichen. Dunkle oder sehr gesättigte Bilder könnten nicht so erscheinen wie in der auf Ihrem Bildschirm sichtbaren Vorschau. Wir empfehlen, zu dunkle Bilder etwas aufzuhellen, um ein optimales Ergebnis zu erzielen.",
      confirm: "Ich bestätige",
      title: "Allgemeine Geschäftsbedingungen",
      content:
        "Ich übernehme die volle Verantwortung für die Verwendung von Bildern oder Grafiken, die ich auf die Webseite hochgeladen habe, und entbinde Ilmyo von jeglicher Verantwortung, die aus der Verletzung von Urheberrechtsgesetzen und aus beleidigenden und verleumderischen Inhalten entsteht.",
      checkbox:
        "Ich bestätige, dass ich die Allgemeinen Geschäftsbedingungen gelesen und verstanden habe.",
    },
    warnings: {
      use_our_emojis: "Verwenden Sie unsere Emojis im Emoji-Tab",
      image_too_big:
        "Hoppla! Es scheint, dass das Bild, das Sie hochladen möchten, zu groß ist.😬",
      update_failed: "Hoppla! Das Update des Designs ist fehlgeschlagen.😬",
      upload_failed: "Hoppla! Das Hochladen des Bildes ist fehlgeschlagen.😬",
      load_failed: "Hoppla! Wir konnten Ihre Anpassung nicht laden.😬",
      back_when_product_in_cart:
        "Sind Sie sicher, dass Sie zum Warenkorb zurückkehren möchten?",
      back_when_product_is_new:
        "Wenn Sie jetzt ausgehen, verlieren Sie Ihr Design und können es nicht wiederherstellen",
    },
    sharing: {
      clipboard_success: "Link kopiert!",
      text: "Schau mal hier 😎!",
      success: "Geteilt ✅!",
      failure: "Probleme, Probleme, Probleme 🛑!",
      title: "Ihre iLMYO Anpassung",
    },
    addToCart: "In den Warenkorb legen",
    preview3D: "3D Vorschau",
    recap: {
      back: "Zurück zur Bearbeitung",
      addToCart: "In den Warenkorb legen",
      editDone: "Zurück zum Warenkorb",
    },
    side_menu: {
      share: "Teilen",
      rollback: "Zurücknehmen",
      zoom: "Zoom",
      guide: "Führer",
    },
    errors: {
      notFoundAction: "Zurück zum Laden",
      notFoundTitle: "UPS!",
      notFoundMessage: "Falscher Weg?",
    },
    onboarding: {
      backButton: "Um die Anpassung zu verlassen, drücken Sie hier",
      bgButton:
        "Wenn Sie die Hintergrundfarbe ändern möchten, können Sie hier drücken",
      textButton:
        "Wenn Sie Text hinzufügen möchten, ist dies der richtige Knopf für Sie",
      imgButton: "Hier können Sie Ihre fantastischen Fotos hochladen",
      emojiButton: "Brauchen Sie Emojis? Suchen Sie hier!",
      previewButton:
        "Neugierig, wie Ihr Produkt aussehen wird? Schauen Sie es sich in 3D an",
      nextButton:
        "Fertig? Dann drücken Sie hier, um den nächsten Druckbereich anzupassen oder zum Warenkorb hinzuzufügen",
      skip: "Überspringen",
    },
    recap_warning_1:
      "Um fortzufahren, stellen Sie sicher, dass Sie hinzugefügt haben",
    recap_warning_2: "mindestens ein Text oder ein Bild",
    recap_warning_3: "in jedem Artikel",
    configurator: { swipeToDelete: "Wischen zum Löschen" },
  },
};
